module.exports = __webpack_public_path__ + "static/img/62-3.2129579.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/62-3.jpg
// module id = 1eeR
// module chunks = 0